import { Capacitor } from "@capacitor/core";

// Native Google Play In-App Review, triggered after positive moments
// (a win, or a 5-day streak). No-op on web. Google itself throttles the
// real dialog, but we add our own client-side guard so we only *ask*
// occasionally: at most once per app build and no more than once per 3 days.
const STORAGE_KEY = "fitjong_review_state";
const MIN_DAYS_BETWEEN = 3;
const BUILD = "i98-journey";

function loadState() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "{}");
  } catch {
    return {};
  }
}

function saveState(s) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(s));
  } catch {
    /* ignore */
  }
}

function daysSince(iso) {
  if (!iso) return Infinity;
  return (Date.now() - new Date(iso).getTime()) / (1000 * 60 * 60 * 24);
}

// reason: "win" | "streak"
export async function maybeRequestReview(reason = "win") {
  if (!Capacitor.isNativePlatform()) return;

  const state = loadState();
  if (state.lastBuild === BUILD) return; // already asked on this build
  if (daysSince(state.lastPromptISO) < MIN_DAYS_BETWEEN) return;

  try {
    const { InAppReview } = await import("@capacitor-community/in-app-review");
    await InAppReview.requestReview();
    saveState({ lastBuild: BUILD, lastPromptISO: new Date().toISOString(), reason });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("in-app review request failed (ignored)", e);
  }
}
